import { useSyncExternalStore } from "react";
import { Alert, AlertTitle, Box } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useIntl } from "../../contexts/IntlContext";
import {
  getEstablishmentBlockedState,
  subscribeEstablishmentBlocked,
} from "../../services/establishmentBlockedStore";

/**
 * Aviso persistente no topo de toda tela autenticada quando qualquer chamada
 * às rotas de painel (/establishments, /lives, /media, /analytics) bater no
 * 403 de bloqueio por atraso na assinatura recorrente do clube. Plugado uma
 * única vez no `Layout` — cobre todas as telas sem precisar de tratamento
 * individual em cada uma (ver `establishmentBlockedStore`/interceptor em
 * `services/api.ts`). Some sozinho assim que uma dessas rotas voltar a
 * responder 200 (assinatura reativada).
 */
export function EstablishmentBlockedBanner() {
  const intl = useIntl();
  const { blocked } = useSyncExternalStore(
    subscribeEstablishmentBlocked,
    getEstablishmentBlockedState
  );

  if (!blocked) return null;

  return (
    <Box sx={{ px: 2, pt: 2 }}>
      <Alert severity="warning" variant="outlined" icon={<LockOutlinedIcon fontSize="inherit" />}>
        <AlertTitle>{intl.formatMessage({ id: "establishment.paymentBlocked.title" })}</AlertTitle>
        {intl.formatMessage({ id: "establishment.paymentBlocked.message" })}
      </Alert>
    </Box>
  );
}
